import { useGetThemesQuery } from '../../__generated__/chirp/com/hubspot/reviews/rpc/ReviewsRpc.hooks';
export function useReviewThemes({
  entityId,
  language,
  reviewType,
  skip
}) {
  var _data$themes, _data$updatedAt;
  const {
    data,
    loading,
    error
  } = useGetThemesQuery({
    variables: {
      entityId,
      language,
      type: reviewType
    },
    skip
  });
  const themes = loading || error ? null : (_data$themes = data === null || data === void 0 ? void 0 : data.themes) !== null && _data$themes !== void 0 ? _data$themes : null;
  const themesUpdatedAt = loading || error ? null : (_data$updatedAt = data === null || data === void 0 ? void 0 : data.updatedAt) !== null && _data$updatedAt !== void 0 ? _data$updatedAt : null;
  return {
    themes,
    themesUpdatedAt,
    loading
  };
}